import { LoadGeneral, useAuthStore } from '@core/global'

// Replaces the Vite entry (src/main.ts). LoadGeneral installs @core's pinia, i18n ($t),
// global components and window helpers ($ajaxGet, $ajaxGraphql, ...).
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(LoadGeneral)

    useAuthStore().requestMemberInfo()
})
